module.exports = __webpack_public_path__ + "img/17355476.610316e5.png";